import * as views from "./view";
import * as utils from "./utils";
import UserService from "./service/UserService";

const userService = new UserService();

export default class App{
    run(){
      this.loadWindowMessageListener();
      views.homeView();
      this.loadEvents();

      localStorage.setItem('appKey', "");
      // localStorage.setItem('appKey', "time-machine");
      // localStorage.setItem('appUser', "oluwafemi+sync@e-limu.org");
      localStorage.setItem('currentVideo', "intro");
      // views.videoView();
    }

    loadEvents(){
      views.start()
      const playBtn = document.getElementById("play-btn");
      if(playBtn){
        playBtn.addEventListener('click', function(e){
          e.preventDefault();  
          views.start()  
        });  
      }

      const closeBtn = document.getElementById("close-btn");          
      let closeCounter = 5;
      const toCloseIntervalId = setInterval(()=>{
        closeCounter--;
        closeBtn.innerHTML = closeCounter;
      }, 1000);
      
      setTimeout(()=>{
        clearInterval(toCloseIntervalId);
        closeBtn.innerHTML = "Close";
        closeBtn.addEventListener('click', function(e){
          e.preventDefault();    
          utils.closeFromParent();
          window.location.href = `${window.location.origin}`;
          views.homeView();
        });    
      }, 5000);
      
      // userService.getUsers().then((data) => {
      //     data = data.filter((i) => { return i.playerparentemail });
      //     for(const userData of data){
      //       const {CompleteTH2022CleanlinessIS, CompleteTH2022MathsNinjaIS, CompleteTH2022TimeMachineIS} = userData;
      //       if(CompleteTH2022CleanlinessIS){
      //         userService.updateUser(userData.id, {CompleteTH2022CleanlinessIS: 1});
      //       }
      //     }    
      // }).catch((e) => {
      //     console.log(e);
      // });
    }

    loadWindowMessageListener(){
      localStorage.setItem('appKey', "");
      localStorage.setItem('appProgress', "");
      localStorage.setItem('appUser', "");
      localStorage.setItem('appReferrer', "");
 
      window.onmessage = function(event) {
        const hasAppData = event.data.data;
        const hasAppAction = event.data.action;
        if(hasAppAction && hasAppData){
          const {app_key, value} = hasAppData;
          localStorage.setItem('appKey', app_key);
          if(hasAppAction === 'sign_in'){
            localStorage.setItem('appUser', value);
          }
        }
      }
    }
}